<div class="modal-term-operator">
  <div class="header">
    <div class="title" mat-dialog-title>{{ title }}</div>
    <div class="close-btn">
      <mat-icon (click)="close()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <div class="sub-title">{{ subTitle }}</div>
  <div class="spinner" *ngIf="loading">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div class="box-term type-string" *ngIf="!loading && selectedTermType === 2">
    <div class="text-title">{{ term_string_title }}</div>
    <div class="text-msg" [innerHTML]="term_string_term"></div>
  </div>
  <div class="box-term" *ngIf="!loading && (selectedTermType === 0)">
    <object *ngIf="urlTerm" [data]="urlTerm" type="application/pdf"></object>
  </div>
  <div class="mock_term" *ngIf="false">
    <div *ngIf="!loading && (selectedTermType === 0)">
      <div class="mock-index-term">Opção {{ indexTerm }} de {{ termsSystem.length }}</div>
      <div *ngIf="indexTerm === 1">
        <div class="mock-title">PDF BASE64 - PRODUTO</div>
        <div class="mock-sub-title">Exibição atual do produto</div>
        <div class="box">
          <object class="mock-box-term" [data]="urlTerm" type="application/pdf"></object>
        </div>
      </div>
      <div *ngIf="indexTerm === 2">
        <div class="mock-title">LINK PDF</div>
        <div class="mock-sub-title">Url do PDF online</div>
        <div class="box">
          <pdf-viewer class="mock-box-term" [src]="mock_link" [original-size]="false"></pdf-viewer>
        </div>
      </div>
      <div *ngIf="indexTerm === 3">
        <div class="mock-title">INNER HTML</div>
        <div class="mock-sub-title">Texto com tags. EX: h1, h2, br, p, div, span, style="", etc</div>
        <div class="box">
          <div class="mock-box-term" [innerHtml]="mock_html"></div>
        </div>
      </div>
      <div *ngIf="indexTerm === 4">
        <div class="mock-title">TEXTO PURO</div>
        <div class="mock-sub-title">Texto sem tags.</div>
        <div class="box">
          <div class="mock-box-term">{{ mock_text }}</div>
        </div>
      </div>
      <div class="mock-box-btn">
        <button mat-raised-button class="wd-50" color="clear" (click)="mockChangeTerm(0)"
          [disabled]="indexTerm === 1">Anterior</button>
        <button mat-raised-button class="wd-50" color="clear" (click)="mockChangeTerm(1)"
          [disabled]="indexTerm === this.termsSystem.length">Próximo</button>
      </div>
    </div>
  </div>
  <div class="box-term" *ngIf="!loading && (selectedTermType === 3)">
    <div class="sub-title">Termo {{ termDisplayed?.numberOfTerm }} de {{ qtdTerm }}</div>
    <div class="title-term">{{ termDisplayed?.description | uppercase }}</div>
    <div class="version-term">{{ termDisplayed?.version }}</div>
    <object *ngIf="termDisplayed?.term" [data]="termDisplayed?.term" type="application/pdf"></object>
  </div>
  <div class="box-check">
    <mat-checkbox class="check-term" [(ngModel)]="checkTermOperator">
      <span class="desc">{{ messageCheck }}</span>
    </mat-checkbox>
  </div>
  <div class="box-btn">
    <button mat-raised-button class="sm" color="primary02" (click)="confirm()"
      [disabled]="!checkTermOperator">{{confirmText}}
    </button>
  </div>
</div>
